import { type LinkProps, Link } from "@tanstack/react-router";
import { Icon } from "icons";
import { Button } from "ui";

interface QuestionnaireSubmissionNavigationButtonProps {
  label: string;
  disabled: boolean;
  linkProps?: LinkProps;
  onClick?: () => void;
  icon: "tabler-chevron-left" | "tabler-chevron-right";
}

export function QuestionnaireSubmissionNavigationButton(
  props: QuestionnaireSubmissionNavigationButtonProps,
) {
  const className = "p-0 size-10 rounded-none";

  if (props.linkProps && !props.disabled) {
    return (
      <Button asChild variant="ghost" className={className}>
        <Link {...props.linkProps} aria-label={props.label}>
          <Icon name={props.icon} />
        </Link>
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant="ghost"
      className={className}
      aria-label={props.label}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <Icon name={props.icon} />
    </Button>
  );
}
